import React from "react";
import WebData from "../../../../Helpers/WebData";
import GiftMerchandiseForm from "./GiftMerchandiseForm";
import ReactMarkdown from "react-markdown";
import "./GiftMerchandise.style.css";

const GiftMerchandise = () => {
  const paragraph =
    "Merchandise gifts help you target specific needs. We have a shortage of fans, fridges, boilers, construction materials, cattle hoist and medical kits. Seasonal fruits and cereals aid in recovery of the sick and injured. Fill this form or call to inquire. Your donations are eligible for exemptions u/s 80(G).";
  return (
    <>
      <section id="giftmerchandise">
        <div className="custom-row">
          <div className="engage-container content-view1 gm-content-wrapper">
            <div className=" gm-para scrollbar-hide">
              <p className="justify-desc scrollbar-hide mb-0">
                <ReactMarkdown>{paragraph}</ReactMarkdown>
              </p>
              <p className="d-flex justify-content-center mb-0">
                <a
                  target="_blank"
                  className="me-2"
                  rel="noopener noreferrer"
                  href={`tel:${WebData.contact.phone}`}
                >
                  <i
                    className="ml-3 mr-1 fa fa-phone"
                    style={{ color: "var(--text-color)", fontSize: "1.1rem" }}
                  ></i>
                </a>
                <a
                  target="_blank"
                  className="me-2"
                  rel="noopener noreferrer"
                  href={`https://wa.me/${WebData.contact.whatsapp}`}
                >
                  <i
                    className="mx-1 fa fa-whatsapp"
                    style={{ color: "var(--text-color)", fontSize: "1.1rem" }}
                  ></i>
                </a>
                <a
                  target="_blank"
                  className="me-2"
                  rel="noopener noreferrer"
                  href={`https://telegram.me/${WebData.contact.telegram}`}
                >
                  <i
                    className="mx-1 fa fa-telegram"
                    style={{ color: "var(--text-color)", fontSize: "1.1rem" }}
                  ></i>
                </a>
                <a
                  target="_blank"
                  className="me-2"
                  rel="noopener noreferrer"
                  href={`mailto:${WebData.contact.mail}`}
                >
                  <i
                    className="mx-1 fa fa-envelope"
                    style={{ color: "var(--text-color)", fontSize: "1.1rem" }}
                  ></i>
                </a>
              </p>
            </div>
            <div
              className="justify-desc px-2 px-md-0 scollbar-hide"
              style={{ overflow: "hidden" }}
            >
              <GiftMerchandiseForm />
            </div>
          </div>
          <div className=" d-flex align-items-center justify-content-center gm-image image-view1">
            <div className="gm-img">
              <img
                className="d-flex"
                src={WebData.giftMerchandiseImg}
                alt="giftMerchandice"
                srcset=""
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default GiftMerchandise;
